import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import axios from 'axios'

Vue.config.productionTip = false
// TELECOM:
//axios.defaults.baseURL = 'http://181.171.59.43:9980/'

// IPLAN:
axios.defaults.baseURL = 'http://190.2.56.200:9980/'  


//axios.defaults.baseURL = 'https://vadi.similia.com.ar:9980/'



 new Vue({
     router,
     store,
     vuetify,
    render: h => h(App)
}).$mount('#app')
